/**
 * External Dependencies
 */
import 'jquery';
import 'alpinejs';
import focus from '@alpinejs/focus'
import lozad from 'lozad';
import validate from 'jquery-validation';
import "jquery-validation/dist/additional-methods.js";

$(document).ready(() => {

    /* https://github.com/madmurphy/cookies.js (GPL3) */
!function(){function e(e,o,t,n,r,s,i){var c="";if(t)switch(t.constructor){case Number:c=t===1/0?"; expires=Fri, 31 Dec 9999 23:59:59 GMT":"; max-age="+t;break;case String:c="; expires="+t;break;case Date:c="; expires="+t.toUTCString()}return encodeURIComponent(e)+"="+encodeURIComponent(o)+c+(r?"; domain="+r:"")+(n?"; path="+n:"")+(s?"; secure":"")+(i&&"no_restriction"!==i.toString().toLowerCase()?"lax"===i.toString().toLowerCase()||1===Math.ceil(i)||!0===i?"; samesite=lax":"none"===i.toString().toLowerCase()||i<0?"; samesite=none":"; samesite=strict":"")}var o=/[\-\.\+\*]/g,t=/^(?:expires|max\-age|path|domain|secure|samesite|httponly)$/i;window.docCookies={getItem:function(e){return e&&decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*"+encodeURIComponent(e).replace(o,"\\$&")+"\\s*\\=\\s*([^;]*).*$)|^.*$"),"$1"))||null},setItem:function(o,n,r,s,i,c,a){return!(!o||t.test(o))&&(document.cookie=e(o,n,r,s,i,c,a),!0)},removeItem:function(o,t,n,r,s){return!!this.hasItem(o)&&(document.cookie=e(o,"","Thu, 01 Jan 1970 00:00:00 GMT",t,n,r,s),!0)},hasItem:function(e){return!(!e||t.test(e))&&new RegExp("(?:^|;\\s*)"+encodeURIComponent(e).replace(o,"\\$&")+"\\s*\\=").test(document.cookie)},keys:function(){for(var e=document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g,"").split(/\s*(?:\=[^;]*)?;\s*/),o=e.length,t=0;t<o;t++)e[t]=decodeURIComponent(e[t]);return e},clear:function(e,o,t,n){for(var r=this.keys(),s=r.length,i=0;i<s;i++)this.removeItem(r[i],e,o,t,n)}}}(),"undefined"!=typeof module&&void 0!==module.exports&&(module.exports=docCookies);

    // Alpine.plugin(focus)

  // Sticky Header on Scroll
  $(window).on('scroll', function() {
    if ($(this).scrollTop() > 150){  
        $('nav.main-nav').addClass("sticky");
    }
    else{
        $('nav.main-nav').removeClass("sticky");
    }
  });

    /* start quote script */
    var gradeOptionsArray = {};
    var sizeOptionsArray = {};

    // Build gradeOptionsArray
    $('select#grades:first option').each(function () {
        var productName = $(this).data('group');

        if (typeof productName !== 'undefined') {
            var productGrade = $(this).val();

            // If the product name doesn't exist in the options array, initialize the structure
            if (!gradeOptionsArray[productName]) {
                gradeOptionsArray[productName] = [];
            }

            // Add the product grade to the grades array
            gradeOptionsArray[productName].push(productGrade);
        }
    });

    // Build sizeOptionsArray
    $('select#sizes:first option').each(function () {
        var productName = $(this).data('product');

        if (typeof productName !== 'undefined') {
            var productSize = $(this).val();

            // If the product name doesn't exist in the options array, initialize the structure
            if (!sizeOptionsArray[productName]) {
                sizeOptionsArray[productName] = [];
            }

            // Add the product size to the sizes array
            sizeOptionsArray[productName].push(productSize);
        }
    });

    $('.products-drop').change(function () {
        var product = $(this).val();
        var gradeData = gradeOptionsArray[product];
        var grades = $(this).closest('.quote-drop').find('.grades-drop');
        var sizes = $(this).closest('.quote-drop').find('.sizes-drop');
        
        // Remove all options except the first
        grades.find('option:not(:first)').remove();
        sizes.find('option:not(:first)').remove();
        
        if (gradeData && typeof gradeData !== 'undefined') {
            gradeData.forEach(function (grade) {
                var option = '<option data-product="' + product + '" value="' + grade + '">' + grade + '</option>';
                grades.append(option);
            });
        }
    });

    $('.grades-drop').change(function () {
        var product = $(this).closest('.quote-drop').find('.products-drop').val();
        var sizeData = sizeOptionsArray[product];
        var sizes = $(this).closest('.quote-drop').find('.sizes-drop');
        
        // Remove all options except the first
        sizes.find('option:not(:first)').remove();
        
        if (sizeData && typeof sizeData !== 'undefined') {
            sizeData.forEach(function (size) {
                var option = '<option value="' + size + '">' + size + '</option>';
                sizes.append(option);
            });
        }
    });

    $('.products-drop').trigger('change');
    $('.grades-drop').trigger('change');
    /* end quote script */
    
/*
  $('.products-drop').each(function(index, el) {
    
    // Quote Select Dropdowns
    $(this).on('change', function(){

        var grades = $(this).closest('.quote-drop').find('.grades-drop');
        var sizes  = $(this).closest('.quote-drop').find('.sizes-drop');

        var product = $(this).val();
        var grade   = grades;
        var i       = 1;

        if( product == '' ){
            grades.val('').prop('disabled', true);
            sizes.val('').prop('disabled', true);
            $('option', grade).filter(function(){
                if($(this).val() != '' ){
                    $(this).addClass('hidden');
                }
            });
        }else{
            grades.val('').prop('disabled', false);
            sizes.val('').prop('disabled', false);

            $('option', grade).filter(function(){
                if ( $(this).attr('data-group') === product ) {
                   $(this).removeClass('hidden');
                    if( i == 1 ){
                        grades.val('').trigger('change');
                    }
                    i++;
                } else {
                    if(!$(this).attr('disabled')){
                        $(this).addClass('hidden');
                    }
                }
            });
        }
    });
});

$('.products-drop').each(function(index, el) {
    $(this).trigger('change');
});

$('.grades-drop').each(function(index, el) {
    
    $(this).on('change', function(){
        var product = $(this).closest('.quote-drop').find('.products-drop');
        var sizes = $(this).closest('.quote-drop').find('.sizes-drop');

        var grade = $(this).val();
        var size  = sizes;
        var i     = 1;
        if( grade == '' || grade == null ){
            sizes.val('').prop('disabled', true);
            $('option', size).filter(function(){
                if($(this).val() != '' ){
                    $(this).addClass('hidden');
                  }
              });
        }else{
            sizes.val('').prop('disabled', false);
            $('option', size).filter(function(){
                //if ( $(this).attr('data-group') === grade && product.find(':selected').val() === $(this).attr('data-product') ) {
                    if (product.find(':selected').val() === $(this).attr('data-product') ) {
                    $(this).removeClass('hidden');
                    if( i == 1 ){
                        sizes.val('').trigger('change');
                    }
                    i++;
                } else {
                    if($(this).val() != '' ){
                        $(this).addClass('hidden');
                    }
                }
            });
        }
    });

});

$('.grades-drop').each(function(index, el) {
    $(this).trigger('change');
});
*/
  // Body Scroll Lock
  var jQuery = document.querySelector.bind(document);
  if(jQuery('#freeQuoteModal').length){
    var $modalOne = jQuery('#freeQuoteModal');
    jQuery('#freeQuoteModalBtn').onclick = function () {
      bodyScrollLock.lock()
    }

    $modalOne.onclick = function (event) {
      bodyScrollLock.unlock()
    }
  }

  if(jQuery('#mmenuModal').length){
    var $modalThree = jQuery('#mmenuModal');
    jQuery('#mmenuModalBtn').onclick = function () {
      bodyScrollLock.lock()
    }
    $modalThree.onclick = function (event) {
      bodyScrollLock.unlock()
    }
  }


  //Free Quote Form Validation
    $("#free-quote").validate({
        rules: {
            FirstName: "required",   
            LastName: "required",  
            Email: {
                required: true,
                email: true
            },
            Gas: "required"
        },
        messages: {
            FirstName: "Please enter your first name",                   
            LastName: "Please enter your last name",                   
            Email: "Please enter your email", 
            Gas: "Please choose a gas"
        },
        errorPlacement: function(error, element) {
          error.insertAfter( element );
        },
                
    });

    //Free Quote Form Validation
    $("#contact-us").validate({
      rules: {
          Name: "required",   
          Email: {
              required: true,
              email: true
          },
          Company: "required",   
          Message: "required"
          
      },
      messages: {
          Name: "Please enter your name",                                
          Email: "Please enter your email",
          Company: "Please enter your company name",
          Message: "Please add a message"   
      },
      errorPlacement: function(error, element) {
        error.insertAfter( element );
      },
              
    });

    if (document.body.classList.contains('single-careers')) {
      //Apply for Job Validation
      $("#apply").validate({
        rules: {
            Name: "required",   
            Email: {
                required: true,
                email: true
            },
            Phone: {
              required: true,
              phoneUS: true
            },
            CoverLetter: "required",   
            Resume: "required"
            
        },
        messages: {
            Name: "Please enter your name",                                
            Email: "Please enter your email",
            Phone: "Please enter your phone number",
            CoverLetter: "Please add a cover letter",
            Resume: "Please add your resume"   
        },
        errorPlacement: function(error, element) {
          error.insertAfter( element );
        },
                
      });
    }


    // Recaptcha v3
    function onSubmit(token) {
      document.getElementById("recapcha").submit();
    }


});

const observer = lozad();
observer.observe();

